export default {
	section_banner: {
		title: {
			one: 'Payment',
			two: 'Method',
		},
		main_title: '& Funding Access',
		paragraph: {
			one: 'Customers can pay at merchants using just their mobile phones. It is fast, secure, and eliminates the need for physical cards or cash.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	method_mid: {
		label: 'Streamline & Simplify',
		title: {
			one: 'JPWorldPay Paid ',
			two: 'To',
			three: 'Affiliated',
			four: 'Stores',
		},
		paragraph: {
			one: 'Settlement by affiliate or settlement for all affiliates allows for flexible and efficient payment processing across your network.',
			two: 'Whether managing individual accounts or handling group-wide settlements, JPWorldPay provides the tools to streamline and simplify your financial operations. Enjoy fast, accurate, and transparent settlements tailored to your business needs.',
		},
		cta_buttons: {
			one: 'Make Payment',
		},
	},

	withdraw_sec: {
		label: 'Withdrawn At Any Time',
		title: {
			one: 'The',
			two: 'Settled',
			three: 'JPWorldPay Is',
			four: 'Fixed',
		},
		paragraph:
			'The settled JPWorldPay amount is fixed, ensuring stability and reliability for your transactions. Once settled, these funds are readily available and can be withdrawn at any time without delay. This flexibility allows you to manage your finances with confidence and convenience, knowing your assets are always within reach. With JPWorldPay, you’re always in control of your funds. No hidden conditions or waiting periods just fast access to your money. Experience financial freedom backed by transparency and trust.',
		cta_buttons: {
			one: 'Withdrawn Currency',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
